document.addEventListener("DOMContentLoaded", function () {
  const productShowCase = document.getElementById("product-showcase");
  if (!productShowCase) return;

  const swiperContainer = document.querySelector(".product-showcase__images");
  if (!swiperContainer) return;

  const imageSwiper = new Swiper(".product-showcase__images", {
    direction: "horizontal",
    spaceBetween: 100,
    allowTouchMove: false,
    breakpoints: {
      768: {
        direction: "vertical",
      },
    },
    on: {
      slideChange: function () {
        handleSlideChange(this.activeIndex);
      },
    },
  });

  const flavourSwiper = new Swiper(".product-showcase__flavours", {
    direction: "vertical",
    spaceBetween: 20,
    allowTouchMove: false,
  });

  const descriptionsSwiper = new Swiper(".product-showcase__descriptions", {
    effect: "fade",
    fadeEffect: { crossFade: true },
    allowTouchMove: false,
    loop: false,
    allowTouchMove: false,
  });

  let backgroundsSwiper = null;

  const handleSlideChange = function (e, slideIndex) {
    flavourSwiper.slideTo(slideIndex);
    descriptionsSwiper.slideTo(slideIndex);
    descriptionsSwiper.update();
    if (!backgroundsSwiper) {
      backgroundsSwiper = new Swiper(".product-showcase__backgrounds", {
        effect: "fade",
        fadeEffect: { crossFade: true },
        allowTouchMove: false,
      });
    }

    backgroundsSwiper.slideTo(slideIndex);
  };

  document
    .querySelectorAll(".product-showcase__buttons button")
    .forEach((button) => {
      button.addEventListener("click", function (e) {
        const slideIndex = parseInt(this.getAttribute("data-index"), 10) - 1;
        imageSwiper.slideTo(slideIndex);
        console.log("descriptionsSwiper", descriptionsSwiper);
        handleSlideChange(e, slideIndex);

        if (window.innerWidth < 768) {
          const targetElement = e.currentTarget;
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
          return;
        }
      });
    });
});
